import videojs from 'video.js';
import './moments-button.js';
import './moments-settings.js';
import utils from './utils.js';
import MomentsList from './moments-list.js';

const registerPlugin = videojs.registerPlugin || videojs.plugin;

// Default options for the plugin.
const defaults = {};

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 * @param    {Object} [options={}]
 */
const onPlayerReady = (player, options) => {
	player.addClass('vjs-moments');
	let control_bar = player.getChild('controlBar');
	if (control_bar) {
		let custom_control_spacer = control_bar.getChild('customControlSpacer');
		let index = custom_control_spacer && control_bar.children_.indexOf(custom_control_spacer) + 1;
		control_bar.addChild('momentsButton', options, index);
	}
	player.addChild('momentsSettings', options);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function moments
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
const moments = function(options) {
	let opts = Object.assign({}, options); 
	if (utils.isTouch() || !opts.types || !opts.types.length || !opts.url) return; // do not show on touch - due to user can't click on small timeline marks
	this.ready(() => {
		opts.momentsList = new MomentsList(this, opts);
		onPlayerReady(this, videojs.mergeOptions(defaults, opts));
	});
};

// Register the plugin with video.js.
registerPlugin('moments', moments);

// Include the version number.
moments.VERSION = '__VERSION__';

export default moments;
